import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuoteDocView, docTitle } from "@/components/quote/QuoteDocView";
import { useApi } from "@/lib/api";

export default function QuoteDocument() {
  const { qid } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { data } = useApi(`/quotations/${qid}/document`);
  useEffect(() => {
    if (!data) return undefined;
    const prev = document.title;
    document.title = docTitle(data);
    const timer = sp.get("print") === "1" ? setTimeout(() => window.print(), 600) : null;
    return () => { document.title = prev; clearTimeout(timer); };
  }, [data, sp]);
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2 mb-4 no-print">
        <Button variant="ghost" onClick={() => nav(-1)} data-testid="doc-back-button"><ArrowLeft className="h-4 w-4 mr-2" />Back</Button>
        {data && !data.assigned && <span className="text-xs text-muted-foreground">Quick quote: customer details stay blank until a client is assigned.</span>}
        <Button onClick={() => window.print()} disabled={!data} className="ml-auto bg-[#d32f2f] hover:bg-[#b71c1c] text-white" data-testid="doc-print-button"><Printer className="h-4 w-4 mr-2" />Print / Download PDF</Button>
      </div>
      {data && <div className="flex justify-center"><QuoteDocView data={data} /></div>}
    </div>
  );
}
